import { render, staticRenderFns } from "./FenologiaList.vue?vue&type=template&id=c9059a26&scoped=true"
import script from "./FenologiaList.vue?vue&type=script&lang=js"
export * from "./FenologiaList.vue?vue&type=script&lang=js"
import style0 from "./FenologiaList.vue?vue&type=style&index=0&id=c9059a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9059a26",
  null
  
)

export default component.exports